export default "__VITE_ASSET__dc4e1b00__"